import { render, staticRenderFns } from "./V2Select.vue?vue&type=template&id=4e4243be&"
import script from "./V2Select.vue?vue&type=script&lang=js&"
export * from "./V2Select.vue?vue&type=script&lang=js&"
import style0 from "./V2Select.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports